<template>
  <generic-modal :title="$t('file')" :buttons="buttons" ref="generic_modal">
    <div class="field">
      <div class="control">
        <generic-uploader
          ref="generic_uploader"
          :idle_label="$t('drop files here')"
          endpoint_url="/drive/file"
          :extra_data="{ drive_uuid: uuid }"
          :allow_multiple="true"
          @error="error_uploading"
          @success="success_uploading"
        />
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p>{{ error }}</p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "FileModal",
  components: { GenericModal, GenericUploader },
  data() {
    return {
      buttons: [
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: { settings: {} },
      error: "",
      uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading() {
      let v = this;
      v.$emit("success");
      // v.$refs.generic_uploader.clear();
      // v.close_modal();
    },
  },
  mounted() {
    let v = this;
    v.uuid = v.$route.query.u;
  },
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
